export const CommonManchesterData = [
  {
    title: "Legal Translation Services",
    detail:
      "Legal translations are a necessary part of any global business. Our legal translation services are highly specialized to provide you with translations that are suited for your law practice, whether you're in environmental law, family law, or corporate law. Get started now.",
    link: "/legal-translation.php",
  },
  {
    title: "Medical Translation Services",
    detail:
      "A medical translator will always be the one to translate all your medical documents. Our medical translators have the knowledge base to ensure your translations fit into all types of medical industries, such as pharmaceuticals, MedTech, and hospital businesses. Contact us today",
    link: "/medical-translation.php",
  },
  {
    title: "Technical Translation Services",
    detail:
      "About 190,000 immigrants enter Melbourne every year, and it's increasing yearly. Our translators are familiar with applications for visas, green cards, and permanent residencies, among others. If you're thinking about applying for immigration, your financial, housing, and other documents may need to be translated. Choose Tomedes today.",
    link: "/technical-translation.php",
  },
];

export const MoreLanguageServices = [
  {
    title: "Interpreting Services",
    detail: "We offer simultaneous and consecutive interpretation services for your business meetings, webinars, conferences, and more.",
    link: "/interpretation-services",
  },
  {
    title: "Localization Services",
    detail: "Looking for localization services in Manchester? We can localize any website, mobile app, or game, suited for the needs of your target locale.",
    link: "/localization-services.php",
  },
  {
    title: "MTPE",
    detail:
      "Our machine translation post editing services have the winning combination of AI machine translation and post editors, providing you with services that can make sure to reach a foreign audience linguistically and culturally.",
    link: "/services/machine-translation-post-editing",
  },
];
